import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=d23f540e&scoped=true&"
import script from "./Stock.vue?vue&type=script&lang=js&"
export * from "./Stock.vue?vue&type=script&lang=js&"
import style0 from "@/assets/stock.css?vue&type=style&index=0&id=d23f540e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23f540e",
  null
  
)

export default component.exports